import {
	FormControl,
	FormControlLabel,
	Radio,
	RadioGroup,
} from "@material-ui/core";
import React, { Fragment, useEffect, useState } from "react";
import paypalCardImage from "../../assets/images/Paypal & Card.svg";
import auto from "../../assets/images/auto.svg";
import exit from "../../assets/images/exit.svg";
import "./PaymentByCard/stylePaymentMethodPopUp.css";
import PaymentByCard from "./PaymentByCard/Components/PaymentByCard";
import PaymentVoucher from "./PaymentVoucher/PaymentVoucher";
import { clone } from "ramda";
import ErrorPopUp from "../../components/ErrorPopUp";
import GiftBox from "../../components/GiftBox";
import { useSelector } from "react-redux";

const PaymentPopUp = (props) => {
	const {
		handleClose,
		t,
		paymentInitializer,
		paymentInitData,
		paymentSubmit,
		paymentURL,
		activeStep,
		setActiveStep,
		getPaymentData,
		paymentDataAfterPayment,
		paypalInitData,
		getPaypalInit,
		callLoginInit,
		paypalLoginInitData,
		paypalComplete,
		paypalSubmit,
		paypalSubmitData,
		getPaymentPaypalData,
		getDataPaymentPaypal,
		loading,
		getPDF,
		amounts,
		getAmounts,
		pdf,
		getVoucherPayment,
		voucherMsg,
		receiveEmail,
		emailHasBeenSent,
		errorMessageHandler,
		errorMessageHandlerVoucher,
		errorMessageHandlerCardInit,
		errorMessageHandlerPaypalInit,
		errorMessageHandlerAmounts,
		errorSubmitPaypal,
		errorPaypalGetData,
		errorEmailSent,
		initialStep = 0,
		initialAmount = 0,
	} = props;

	const [paymentMethod, setPaymentMethod] = React.useState("paypalOrCard");
	const [payByCard, setPayByCard] = React.useState(false);
	const [payByVoucher, setPayByVoucher] = React.useState(false);
	const [panelContent, setPanelContent] = React.useState(true);
	const [paymentInitialData, setPaymentInitialData] = useState({});
	const [openErrorPopUp, setOpenErrorPopUp] = useState(false);
	const [isInitInProgress, setIsInitInProgress] = useState(false);

	const { isTourist } = useSelector(
		(state) => state.BalanceReducer.payloadAfterLogIn,
	);

	const handleChange = (event) => {
		setPaymentMethod(event.target.value);
	};

	useEffect(() => {
		if (errorMessageHandlerPaypalInit) {
			setOpenErrorPopUp(true);
		}
	}, [errorMessageHandlerPaypalInit]);

	useEffect(() => {
		let tempInitData = clone(paymentInitData);
		if (paymentMethod === "paypalOrCard") {
			setPaymentInitialData(tempInitData);
		}
	}, [paymentInitData]);

	useEffect(() => {
		if (initialStep === 1) {
			setPaymentMethod("paypalOrCard");
			setPayByCard(false);
			setPayByVoucher(false);
			setPanelContent(false);
			setIsInitInProgress(true);
			paymentInitializer();
		}
	}, [initialStep, paymentInitializer]);

	useEffect(() => {
		if (!isInitInProgress || loading) return;
		if (errorMessageHandlerCardInit) {
			setIsInitInProgress(false);
			if (!isTourist) {
				setPanelContent(true);
				setPayByCard(false);
			}
			setOpenErrorPopUp(true);
			return;
		}
		if (Object.keys(paymentInitData || {}).length > 0) {
			setIsInitInProgress(false);
			setPayByCard(true);
		}
	}, [
		isInitInProgress,
		loading,
		errorMessageHandlerCardInit,
		paymentInitData,
		isTourist,
	]);

	const handleErrorPopUpDismiss = () => {
		setOpenErrorPopUp(false);
		if (isTourist) {
			handleClose();
		}
	};

	const showCheckoutModal = !(isTourist && openErrorPopUp);

	const handlerContinueButton = (paymentMethod) => {
		if (paymentMethod === "paypalOrCard" && !errorMessageHandlerPaypalInit) {
			setPayByCard(false);
			setPanelContent(false);
			setIsInitInProgress(true);
			paymentInitializer();
		} else if (paymentMethod === "voucher") {
			setPayByVoucher(true);
			setPanelContent(false);
		} else if (
			paymentMethod === "paypalOrCard" &&
			errorMessageHandlerPaypalInit
		) {
			setOpenErrorPopUp(true);
		}
	};
	let panel = null;
	if (payByCard) {
		panel = (
			<PaymentByCard
				t={t}
				setPayByCard={setPayByCard}
				getAmounts={getAmounts}
				amounts={amounts}
				setPanelContent={setPanelContent}
				handleClose={handleClose}
				paymentMethod={paymentMethod}
				handlerContinueButton={handlerContinueButton}
				paymentInitialData={paymentInitialData}
				paymentSubmit={paymentSubmit}
				paymentURL={paymentURL}
				getPaymentData={getPaymentData}
				paymentDataAfterPayment={paymentDataAfterPayment}
				paypalInitData={paypalInitData}
				getPaypalInit={getPaypalInit}
				callLoginInit={callLoginInit}
				paypalLoginInitData={paypalLoginInitData}
				paypalComplete={paypalComplete}
				paypalSubmit={paypalSubmit}
				paypalSubmitData={paypalSubmitData}
				getPaymentPaypalData={getPaymentPaypalData}
				getDataPaymentPaypal={getDataPaymentPaypal}
				loading={loading}
				getPDF={getPDF}
				pdf={pdf}
				receiveEmail={receiveEmail}
				emailHasBeenSent={emailHasBeenSent}
				errorMessageHandler={errorMessageHandler}
				openErrorPopUp={openErrorPopUp}
				setOpenErrorPopUp={setOpenErrorPopUp}
				errorMessageHandlerAmounts={errorMessageHandlerAmounts}
				errorMessageHandlerCardInit={errorMessageHandlerCardInit}
				activeStep={activeStep}
				setActiveStep={setActiveStep}
				payByCard={payByCard}
				errorSubmitPaypal={errorSubmitPaypal}
				errorPaypalGetData={errorPaypalGetData}
				errorEmailSent={errorEmailSent}
				initialStep={initialStep}
				initialAmount={initialAmount}
			/>
		);
	} else if (payByVoucher) {
		panel = (
			<PaymentVoucher
				t={t}
				setPayByVoucher={setPayByVoucher}
				setPanelContent={setPanelContent}
				handleClose={handleClose}
				paymentMethod={paymentMethod}
				handlerContinueButton={handlerContinueButton}
				loading={loading}
				getPDF={getPDF}
				pdf={pdf}
				getVoucherPayment={getVoucherPayment}
				voucherMsg={voucherMsg}
				errorMessageHandlerVoucher={errorMessageHandlerVoucher}
			/>
		);
	} else if (isInitInProgress) {
		panel = (
			<div className="paymentContent firstElement">
				<span className="modalTitle">
					{isTourist ? t("billPayment") : t("paymentAndRenewal")}
				</span>
				<span
					className="loadingSpinner"
					style={{
						display: "block",
						position: "static",
						border: "4px solid #3d5265",
						borderRightColor: "transparent",
						margin: "20px auto",
					}}
				/>
			</div>
		);
	} else {
		panel = (
			<span className="modalTitle">
				{isTourist ? t("billPayment") : t("paymentAndRenewal")}
			</span>
		);
	}

	return (
		<Fragment>
			{showCheckoutModal ? (
				<div className="hover_bkgr_terms_container_prof popup_open">
					<div className="simple-popup">
						<div className="simple-popup-content simple-popup-content-confirm checkoutPopupContent">
							<div>
								{panel}
								{panelContent ? (
									<div className="paymentContent firstElement">
										<div className="removePayments">
											<div className="paymentContentTitle">
												{t("paymentParagraphMessage")}*
											</div>
											<GiftBox t={t} />
											<div className="paymentMethod">
												<div className="paymentMethodCol withBorder">
													<FormControl>
														<RadioGroup
															value={paymentMethod}
															onChange={handleChange}
															aria-labelledby="demo-radio-buttons-group-label"
															defaultValue="paypalOrCard"
															name="radio-buttons-group"
														>
															<FormControlLabel
																value="paypalOrCard"
																control={<Radio />}
																label={
																	<div>
																		<label
																			className="payment-type-method"
																			htmlFor="loadBalanceOption"
																		>
																			<div className="payment-type-method-text">
																				<span className="textb">
																					{t("paymentByCard")}*
																				</span>
																				<div style={{ fontSize: "12px" }}>
																					*{t("sale")}
																				</div>
																				{t("paymentByCardContent")}
																			</div>
																			<div className="payment-type-method-img">
																				<img src={paypalCardImage} />
																			</div>
																		</label>
																	</div>
																}
															/>
															{!isTourist && (
																<FormControlLabel
																	value="voucher"
																	control={<Radio />}
																	label={
																		<label
																			className="payment-type-method"
																			htmlFor="autoOption"
																		>
																			<div className="payment-type-method-text">
																				<span className="textb">
																					{t("paymentByVoucher")}
																				</span>
																				<br />
																				{t("paymentByVoucherContent")}
																			</div>
																			<div className="payment-type-method-img">
																				<img src={auto} alt={t("auto")} />
																			</div>
																		</label>
																	}
																/>
															)}
														</RadioGroup>
													</FormControl>
												</div>
											</div>
										</div>
										<div className="buttonOuter inlineButtons rightAligned">
											<a
												onClick={() => {
													handlerContinueButton(paymentMethod);
												}}
												className="button primaryButton primaryButtonNormal"
											>
												{t("continue")}
												<span className="loadingSpinner"></span>
											</a>
										</div>
										<img
											src={exit}
											className="close"
											onClick={handleClose}
											alt={t("close")}
										/>
									</div>
								) : null}
							</div>
						</div>
					</div>
				</div>
			) : null}
			{openErrorPopUp ? (
				<ErrorPopUp
					setOpenErrorPopUp={handleErrorPopUpDismiss}
					openErrorPopUp={openErrorPopUp}
					t={t}
					text={t("errorGeneral")}
				/>
			) : null}
		</Fragment>
	);
};

export default PaymentPopUp;
